<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <platform-logo />
      <h2 class="brand-text text-primary ml-1">
        {{ platformName() }}
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{ $t('modules.purchases._confirmation.order_placed_title') }} ✅
        </h2>
        <p class="mb-3">
          {{ $t('modules.purchases._confirmation.order_placed_description') }}
        </p>
        <p class="row justify-content-center m-0 mb-2">
          <span>{{ $t('modules.purchases._confirmation.purchase_id') }}:</span>
          <span>{{ $route.params.id }}</span>
        </p>

        <b-img
          fluid
          :src="imgUrl"
          alt="Purchase Placed"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BLink, BImg,
} from 'bootstrap-vue'
import PlatformLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import { platformName } from '@core/utils/utils'

export default {
  components: {
    PlatformLogo,
    BLink,
    BImg,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/purchase-confirmation.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/purchase-confirmation.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: { platformName },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
